/* unplugin-vue-components disabled */// extracted by mini-css-extract-plugin
export default {"tab_wrap":"tab_wrap-ecb37ee9","active":"active-e56c01d5"};